var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlight = function SvgHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m15.197 6.055.824-.798 1.648 1.596-.824.798zm-3.297 0 1.648-1.596.824-.798a2.385 2.385 0 0 1 3.297 0l1.648 1.596c.91.882.91 2.31 0 3.192l-.824.798-1.648 1.596-4.12 3.99-1.65 1.596-.193.188-3.112 1.127a2.38 2.38 0 0 1-2.463-.517 2.2 2.2 0 0 1-.534-2.385l1.164-3.013.194-.188 1.648-1.596zm3.297 3.192-4.121 3.99-1.648-1.596 4.12-3.99zm-8.24 6.382.897-2.32 1.5 1.452zm-1.791 3.114c-.644 0-1.166.505-1.166 1.129C4 20.495 4.522 21 5.166 21h12.82c.644 0 1.166-.505 1.166-1.128 0-.624-.522-1.13-1.166-1.13z",
    clipRule: "evenodd"
  })));
};
export default SvgHighlight;